import { render, staticRenderFns } from "./secondProductClassify.vue?vue&type=template&id=100f7983&scoped=true"
import script from "./secondProductClassify.vue?vue&type=script&lang=js"
export * from "./secondProductClassify.vue?vue&type=script&lang=js"
import style0 from "./secondProductClassify.vue?vue&type=style&index=0&id=100f7983&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100f7983",
  null
  
)

export default component.exports